import { render, staticRenderFns } from "./course_list.vue?vue&type=template&id=b97cda04&scoped=true"
import script from "./course_list.vue?vue&type=script&lang=js"
export * from "./course_list.vue?vue&type=script&lang=js"
import style0 from "./course_list.vue?vue&type=style&index=0&id=b97cda04&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b97cda04",
  null
  
)

export default component.exports